import { useRef, useState } from "preact/hooks";
import { CharCount } from "./CharCount";
import { autosize } from "../lib/textarea";
import { MAX_QUESTION_LENGTH } from "../lib/config";
import { hasPendingMatch, isStreaming, submitQuestion } from "../state";

/** Follow-up composer shown at the bottom of the chat view. */
export function Composer() {
  const [value, setValue] = useState("");
  const ref = useRef<HTMLTextAreaElement>(null);
  const busy = isStreaming.value;
  // A match-presentation turn is waiting on the user's choice; a follow-up
  // would otherwise start a conversation with two unanswered user messages.
  const blocked = hasPendingMatch.value;

  function send() {
    if (busy || blocked || !value.trim()) return;
    void submitQuestion(value);
    setValue("");
    if (ref.current) ref.current.style.height = "auto";
  }

  function onKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      send();
    }
  }

  return (
    <div class="composer">
      <div class="content">
        <div class="composer__row">
          <textarea
            ref={ref}
            class="textarea composer__input"
            rows={1}
            maxLength={MAX_QUESTION_LENGTH}
            value={value}
            disabled={busy || blocked}
            placeholder={blocked
              ? "Choose how to answer above…"
              : busy
              ? "The judge is answering…"
              : "Ask a follow-up…"}
            aria-label="Follow-up question"
            onInput={(event) => {
              setValue(event.currentTarget.value);
              autosize(event.currentTarget);
            }}
            onKeyDown={onKeyDown}
          />

          <button
            type="button"
            class="btn btn--primary composer__send"
            onClick={send}
            disabled={busy || !value.trim() || blocked}
            aria-label="Send follow-up"
          >
            ↑
          </button>
        </div>
        <CharCount length={value.length} />
      </div>
    </div>
  );
}
